import {
  usePaginatedResource,
  useResourceItem,
  useCreateResource,
  useEditResource,
} from "./useCrudResource"
import {
  getAccountDayCloses,
  getAccountDayClose,
  closeAccountDay,
  reopenAccountDayClose,
} from "api/accountDayCloseApi"

export const ACCOUNT_DAY_CLOSE_QUERY_KEY = "account-day-closes"

export const useAccountDayCloses = (params = {}, enabled = true) => {
  return usePaginatedResource(
    ACCOUNT_DAY_CLOSE_QUERY_KEY,
    getAccountDayCloses,
    params,
    enabled
  )
}

export const useAccountDayClose = (id, enabled = true) => {
  return useResourceItem(ACCOUNT_DAY_CLOSE_QUERY_KEY, getAccountDayClose, id, enabled)
}

export const useCloseAccountDay = () => {
  return useCreateResource(closeAccountDay, ACCOUNT_DAY_CLOSE_QUERY_KEY)
}

export const useReopenAccountDayClose = () => {
  return useEditResource(reopenAccountDayClose, ACCOUNT_DAY_CLOSE_QUERY_KEY)
}
